import { Component } from '@angular/core';
import { SubmitterDetails, LegalEntityDetail, LeiGlobalModel, PackageDetails, PaymentDetails, InvoiceDetails, InvoiceAddress, Contact, VerificationDetails } from '../model/lei-model';
import { LeiService } from '../backend-service/lei-service';
import { Subscription } from 'rxjs';
import { FormControl, Validators} from '@angular/forms';
import { SharedService } from '../backend-service/shared-service';
import { DialogsService } from '../backend-service/dialogs.service';

@Component({
  selector: 'app-lei',
  templateUrl: './lei.component.html',
  styleUrls: ['./lei.component.scss']
})
export class LeiComponent {

  private formSubscription: Subscription;
  private codeSubscription : Subscription;
  private verifySubscription : Subscription;
  private leiModel:LeiGlobalModel;
  visibleTab:number = 1;
  private codeSubmitted: boolean = false;

  private fullNameFormControl : FormControl;
  private emailFormControl : FormControl;

  private onboardCodeFormControl : FormControl;

  private secondTabNavigationAllowed : boolean = true;

  private codeErrorOnPage : boolean = false;
  private codeErrorMessage : string;
  private serverError = false;
  private formSubmitted = false;


  constructor(private leiService:LeiService,private _sharedService: SharedService, private dialogsService: DialogsService) {

    this.initializeFormControlsForValidation();

    this.leiModel = new LeiGlobalModel();
    this.leiModel.submitter = new SubmitterDetails();
    this.leiModel.legalEntityDetails = new Array<LegalEntityDetail>();
    this.leiModel.verificationDetails = new VerificationDetails();

    this.addLeiForm();
  }

  private initializeFormControlsForValidation() : void {

    let EMAIL_REGEX = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

    this.fullNameFormControl = new FormControl('', [
      Validators.required]);

    this.emailFormControl = new FormControl('', [
      Validators.required,
      Validators.pattern(EMAIL_REGEX)]);

    this.onboardCodeFormControl = new FormControl('', [
      Validators.required]);

  }

  //add an legalEntityDetail to LegalEntityDetails array and give the value of count to ngFor
  private addLeiForm(){
    let legalEntityDetail = new LegalEntityDetail();
    legalEntityDetail.isCardOpen = true;
    legalEntityDetail.mifidInScope = this._sharedService.getValue();
    legalEntityDetail.leiCorrelationId = this.leiModel.legalEntityDetails.length;
    legalEntityDetail.packagesDetails = new Array<PackageDetails>();
    let firstPackageDetails= new PackageDetails();
    firstPackageDetails.packageCorrelationId = legalEntityDetail.packagesDetails.length;
    legalEntityDetail.packagesDetails.push(firstPackageDetails);
    legalEntityDetail.paymentDetails = new PaymentDetails();
    legalEntityDetail.paymentDetails.preferredCurrency = 'USD';
    legalEntityDetail.invoiceDetails = new InvoiceDetails();
    legalEntityDetail.invoiceDetails.address = new InvoiceAddress();
    legalEntityDetail.contacts = new Array<Contact>();
    let firstContact = new Contact();
    firstContact.contactCorrelationId = legalEntityDetail.contacts.length;
    legalEntityDetail.contacts.push(firstContact);
    this.closeAnyOpenCard();
    this.leiModel.legalEntityDetails.push(legalEntityDetail);
    this.secondTabNavigationAllowed = true;
  }

  //close any open card before adding a new card
  private closeAnyOpenCard(){
    for(let i=this.leiModel.legalEntityDetails.length-1; i>=0; i--) {
      if(this.leiModel.legalEntityDetails[i].isCardOpen){
        this.leiModel.legalEntityDetails[i].isCardOpen = false;
      }
    }
  }

  //close any other card if any card is opened
  private onCardStateChange(event){
    for(let i=this.leiModel.legalEntityDetails.length-1; i>=0; i--) {
      if( this.leiModel.legalEntityDetails[i].leiCorrelationId !== event.leiCorrelationId){
        this.leiModel.legalEntityDetails[i].isCardOpen = false;
      }
    }
  }

  //add a new package
  private onPackagesModelChange(event) {
    let packageDetails = new PackageDetails();
    packageDetails.packageCorrelationId = this.leiModel.legalEntityDetails[event.leiCorrelationId].packagesDetails.length;
    this.leiModel.legalEntityDetails[event.leiCorrelationId].packagesDetails.push(packageDetails);
  }

  //add a new contact
  private onContactsModelChange(event) {
    let contact = new Contact();
    contact.contactCorrelationId = this.leiModel.legalEntityDetails[event.leiCorrelationId].contacts.length;
    this.leiModel.legalEntityDetails[event.leiCorrelationId].contacts.push(contact);
  }

  private removeLeiFromModel(event) {
    for(let i=this.leiModel.legalEntityDetails.length-1; i>=0; i--) {
      if( this.leiModel.legalEntityDetails[i].leiCorrelationId == event.leiCorrelationId) {
        this.leiModel.legalEntityDetails.splice(i,1);
      }
    }

    if (this.leiModel.legalEntityDetails.length == 1) {
      this.leiModel.legalEntityDetails[0].isCardOpen = true;
    }
  }

  //get the code
  private getCode() : void {
    //console.log('need to get code with these details' + JSON.stringify(this.leiModel));
    this.codeSubmitted = true; //todo - move this to success handler
    let leiModelForSubmission = this.stripContactsFromLEI();
    this.codeSubscription = this.leiService.submitCodeData(leiModelForSubmission)
      .subscribe(
        data => {
          //console.log('response for code submission', data);
          this.leiModel.verificationDetails = data['verificationDetails'];
        },
        err => {
          //console.log('error for code submission' + err);
        }
      );
  }

  private stripContactsFromLEI() :void{
    let tempLeiModel = JSON.parse(JSON.stringify(this.leiModel));
    for(let i=tempLeiModel.legalEntityDetails.length-1; i>=0; i--) {
      if(!(tempLeiModel.legalEntityDetails[i].mifidInScope === 'IN' || tempLeiModel.legalEntityDetails[i].mifidInScope === 'OPTIN')){
        tempLeiModel.legalEntityDetails[i].contacts = [];
        tempLeiModel.legalEntityDetails[i].packagesDetails = [];
        tempLeiModel.legalEntityDetails[i].paymentDetails.preferredCurrency = '';
      }
    }
    return tempLeiModel;
  }

  //submit the form
  submitFullFormDetails() :void{
    this.codeErrorOnPage = false;
    this.serverError = false;
    //console.log('form data-' + this.leiModel);
    let leiModelForSubmission = this.stripContactsFromLEI();
    this.formSubscription = this.leiService.submitLeiData(leiModelForSubmission)
      .subscribe(
        data => {
          //console.log('the response from server is' + data);
          if(data['success'] == false) {
            //console.log('response is success false');
            if(data.hasOwnProperty('errors')){
              //console.log('got unique code error');
              this.codeErrorOnPage = true;
              this.codeErrorMessage = data['errors'][0].toString();
            }
          }
          else{
            //console.log('response is success true');
            this.formSubmitted = true;
          }
        },
        err  => {
          this.serverError = true;
          //console.log('the error from server is' + err);
        }
      );
  }

  private navigateToFirstTab(){
    this.visibleTab = 1;
  }

  private navigateToSecondTab(){
    this.visibleTab = 2;
  }

  private navigateToThirdTab() {
    let leiModelForSubmission = this.stripContactsFromLEI();
    this.verifySubscription = this.leiService.submitVerifyData(leiModelForSubmission)
      .subscribe(
        data => {
          //console.log('the response from server is' + data);

          if(data['success'] == false) {
            //console.log('response is success false' + data['errorSummary']);
            this.showPageErrors(data['errorSummary']);
          }
          else{
            //console.log('response is success true. move to next tab.');
            this.visibleTab = 3;

            // TODO: check validation for second tab also.
            if (!this.isFirstTabInvalid()) {
              this.getCode();
            }
          }
        },
        err  => {
          //console.log('the error from server is' + err);
        }
      );
  }

  private showPageErrors(errors: Array<string>): void{
    this.dialogsService
      .confirm(errors);
  }

  private isFirstTabInvalid():boolean {
    return this.fullNameFormControl.invalid || this.emailFormControl.invalid;
  }

  private isCodeEntered():boolean {
    return this.onboardCodeFormControl.invalid;
  }

  private disableNavigation(event):void {
    this.secondTabNavigationAllowed = event;
  }

  private copyInvoiceFromLastLEI(event):void {
    for (let i = this.leiModel.legalEntityDetails.length - 1; i >= 0; i--) {
      if (this.leiModel.legalEntityDetails[i].leiCorrelationId == event.event.leiCorrelationId) {
        if (event.copy == true){
          // for (let prop in this.leiModel.legalEntityDetails[i].invoiceDetails)
          //   this.leiModel.legalEntityDetails[i].invoiceDetails[prop] = this.leiModel.legalEntityDetails[i - 1].invoiceDetails[prop];
            this.leiModel.legalEntityDetails[i].invoiceDetails.name = this.leiModel.legalEntityDetails[i-1].invoiceDetails.name;
            this.leiModel.legalEntityDetails[i].invoiceDetails.email = this.leiModel.legalEntityDetails[i-1].invoiceDetails.email;
            this.leiModel.legalEntityDetails[i].invoiceDetails.phone = this.leiModel.legalEntityDetails[i-1].invoiceDetails.phone;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line1 = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.line1;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line2 = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.line2;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line3 = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.line3;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.city = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.city;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.postcode = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.postcode;
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.country = this.leiModel.legalEntityDetails[i-1].invoiceDetails.address.country ;
        } else {
            this.leiModel.legalEntityDetails[i].invoiceDetails.name = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.email = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.phone = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line1 = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line2 = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.line3 = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.city = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.postcode = '';
            this.leiModel.legalEntityDetails[i].invoiceDetails.address.country = '';
        }
      }
    }
  }

}
